import React, {useCallback} from "react";
import './dashboard.css'
import Planner from "../Planner and Organizer/planner";

const Dashbaord = () => {
    return<Planner/>
}

export default Dashbaord